<template>
  <div class="p-the-template-l">
    <TheBreadcrumb />
    <div class="p-the-template-l__inner">
      <div class="p-the-template-l__header">
        <slot name="header">
          <CommonHeading v-if="heading" :block-large-sp="true">{{
            heading
          }}</CommonHeading>
        </slot>
      </div>
      <div class="p-the-template-l__body">
        <div
          v-if="
            indicateSearchForm || indicateSearchButton || indicateSortedButton
          "
          class="p-the-template-l__body__header"
        >
          <div
            v-if="indicateSearchForm"
            ref="searchFormElement"
            class="p-the-template-l__search"
            :class="executeSearchFormDomAnimation ? searchFormClassName : ''"
            :style="isSmartPhone ? serchFormStyle : {}"
          >
            <FormSearch
              v-model:search="search"
              :placeholder="searchPlaceholder"
              @do-search="doSearch"
            />
            <div>
              <ValidationErrorText v-show="error">
                {{ error }}
              </ValidationErrorText>
            </div>
          </div>
          <div
            v-if="indicateSearchButton || indicateSortedButton"
            class="p-the-template-l__right-col"
          >
            <div
              v-if="indicateSearchButton"
              class="p-the-template-l__shown-search-form-button"
            >
              <button
                class="p-the-template-l__shown-search-form-button__button"
                @click="switchSearchFormState"
              >
                <ButtonRefineBase>検索</ButtonRefineBase>
              </button>
            </div>

            <div v-if="indicateSortedButton" class="p-the-template-l__sorted">
              <ButtonRefine
                v-model:refine="sorted.target"
                :heading="filterHeading"
                icon="arrow"
                icon-color="#bdbdbd"
                :refine-item-list="sorted.itemList"
                :shown="sorted.shownState"
                @do-sort="doSort($event)"
                @switch-refine-state="switchSortedState"
              />
            </div>
          </div>
        </div>
        <div
          ref="contentElement"
          class="p-the-template-l__body__content"
          :style="contentElementStyle"
        >
          <slot name="contents" />
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { gsap } from "gsap";
import FormSearch from "@/common/components/atoms/FormSearch.vue";
import ButtonRefine from "@/common/components/atoms/ButtonRefine.vue";
import ButtonRefineBase from "@/common/components/atoms/ButtonRefineBase.vue";
import { Options, Vue } from "vue-class-component";
import ValidationErrorText from "@/common/components/atoms/ValidationErrorText.vue";

@Options({
  props: {
    error: { type: String, default: null },
    sorted: { type: Object },
    heading: { type: [String, Boolean], default: false, required: true },
    filterHeading: { type: [String, Boolean], default: false, required: true },
    indicatedItem: { type: Array, default: ["search", "button"] },
    searchPlaceholder: { type: String, default: "キーワードで探す" },
    searchKeyword: { type: String, default: "" }
  },
  components: {
    FormSearch,
    ButtonRefine,
    ButtonRefineBase,
    ValidationErrorText
  },
  watch: {
    isSp() {
      this.initSearchFormDomAnimation();
    },
    shownSearchFormState() {
      this.animationSearchFormDom(this.$refs.searchFormElement);
    }
  }
})
export default class TheTemplateL extends Vue {
  declare $refs: {
    contentElement: HTMLElement;
    searchFormElement: HTMLElement;
  };

  error!: string;

  isSp!: boolean;
  closeModalState!: boolean;
  search = "";
  searchUriBase: Array<string> = ["/l01/"];
  executeSearchFormDomAnimation = false;
  shownSearchFormState!: boolean;
  searchFormClassName = "p-the-template-l__search--animation";
  serchFormStyle: Record<string, any> = {
    visibility: "hidden",
    opacity: 0
  };

  sorted!: any;
  heading!: string | boolean;
  filterHeading!: string | boolean;
  indicatedItem!: Array<string>;
  searchPlaceholder!: string;
  searchKeyword!: string;

  get indicateSearchForm() {
    const indicatedItem = this.indicatedItem;
    const keyword = "search";
    return indicatedItem.includes(keyword);
  }

  get indicateSearchButton() {
    const indicatedItem = this.indicatedItem;
    return indicatedItem.includes("searchButton");
  }

  get indicateSortedButton() {
    const indicatedItem = this.indicatedItem;
    const keyword = "sorted";
    return indicatedItem.includes(keyword);
  }

  get contentElementStyle() {
    const executeSearchFormDomAnimation = this.executeSearchFormDomAnimation;
    let styleObject = {};

    if (executeSearchFormDomAnimation === false) {
      styleObject = {
        marginTop: 0
      };
    }

    return styleObject;
  }

  get isSmartPhone() {
    if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
      return true;
    } else {
      return false;
    }
  }

  doSort($event: any) {
    this.$emit("do-sort", $event);
  }

  mounted() {
    this.indicatedItem;
    this.heading;
    this.searchKeyword;
	this.search = this.searchKeyword;
    this.shownSearchFormState = false;
  }

  async created() {
    this.indicatedItem;
    this.heading;
    this.searchKeyword;
    this.initSearchFormDomAnimation();
    this.initSearchKeyword();
  }

  initSearchKeyword() {
    this.search = this.searchKeyword;
  }

  async doSearch() {
    this.$emit("do-search", this.search);
  }

  switchSortedState(value: any) {
    this.sorted.shownState = value;
  }

  switchSearchFormState() {
    this.shownSearchFormState = !this.shownSearchFormState;
    if (this.serchFormStyle.visibility == "hidden") {
      this.serchFormStyle.visibility = "inherit";
      this.serchFormStyle.opacity = 1;
    } else if (this.serchFormStyle.visibility == "inherit") {
      this.serchFormStyle.visibility = "hidden";
      this.serchFormStyle.opacity = 0;
    }
  }

  initSearchFormDomAnimation() {
    const { isSp, indicateSearchButton } = this;
    const executeSearchFormDomAnimation = isSp && indicateSearchButton;

    this.executeSearchFormDomAnimation = executeSearchFormDomAnimation;
    this.shownSearchFormState = !executeSearchFormDomAnimation;
  }

  animationSearchFormDom(el: any, shown = this.shownSearchFormState) {
    const executeSearchFormDomAnimation = this.executeSearchFormDomAnimation;
    const { contentElement } = this.$refs;
    const speed = 0.2;
    const animationStyle = {
      formSearchElement: {
        autoAlpha: shown ? 1 : 0
      },
      contentElement: {
        marginTop:
          shown && executeSearchFormDomAnimation ? `${60 / 16}rem` : "0rem"
      }
    };

    gsap.to(el, speed, animationStyle.formSearchElement);
    gsap.to(contentElement, speed, animationStyle.contentElement);
  }
}
</script>

<style lang="scss" scoped>
.p-the-template-l {
  &__inner {
    @include pc {
      max-width: rem(1110);
      margin: 0 auto;
      padding: rem(16) 0 rem(56);
    }

    @include sp {
      padding: rem(8) 0 rem(48);
    }
  }

  &__header {
  }

  &__search {
    @include pc {
      width: rem(288);
      min-width: rem(288);
    }

    &--animation {
      @include sp {
        width: 100%;
        position: absolute;
        padding-top: rem(60);
      }
    }
  }

  &__right-col {
    @include sp {
      display: flex;
      flex-direction: flex-end;
      justify-content: space-between;
      position: relative;
      z-index: 1;
    }
  }

  &__shown-search-form-button {
    @include pc {
      display: none;
    }
    @include sp {
      width: cal(136, 288);
      min-width: cal(136, 288);
    }

    &__button {
      @include sp {
        display: block;
        width: 100%;
      }
    }
  }

  &__sorted {
    @include pc {
      width: rem(180);
      min-width: rem(180);
    }
    @include sp {
      width: cal(136, 288);
      min-width: cal(136, 288);
    }
  }

  &__body {
    @include pc {
      padding-top: rem(32);
    }
    @include sp {
      padding-top: rem(24);
    }
    background-color: $common-white;
    border-radius: rem(4);

    &__header {
      @include pc {
        display: flex;
        justify-content: space-between;
      }
      position: relative;
    }
  }
}
</style>
